import { AirplaneInFlight, Boat, Package, Train, Truck } from "@phosphor-icons/react"

type ShipmentMethodProps = IconProps & {
  shipmentMethod?: string
}

type IconProps = {
  color?: string
  size?: string | number
  weight?: "thin" | "light" | "regular" | "bold" | "fill"
}

const SHIPMENT_METHOD_DICT: Record<string, string> = {
  // AIR
  air: "Air",
  plane: "Air",
  "air freight": "Air",
  airplane: "Air",
  aircraft: "Air",

  // SEA
  sea: "Sea",
  ocean: "Sea",
  "ocean freight": "Sea",
  boat: "Sea",
  ship: "Sea",

  // ROAD
  road: "Road",
  truck: "Road",
  "truck freight": "Road",
  lorry: "Road",
  van: "Road",

  // TRAIN
  rail: "Rail",
  train: "Rail",
  "train freight": "Rail",
  locomotive: "Rail",
  railway: "Rail",
} as const

export default function ShipmentMethodIcon({
  shipmentMethod = "unknown",
  color,
  size,
  weight,
}: ShipmentMethodProps) {
  const method: string = shipmentMethod
    ? SHIPMENT_METHOD_DICT[shipmentMethod.toLowerCase()] || "Unknown"
    : "Unknown"

  switch (method) {
    case "Air":
      return <AirplaneInFlight color={color} size={size} weight={weight} />
    case "Sea":
      return <Boat color={color} size={size} weight={weight} />
    case "Road":
      return <Truck color={color} size={size} weight={weight} />
    case "Rail":
      return <Train color={color} size={size} weight={weight} />
    default:
      console.info("Unknown shipment method:", shipmentMethod?.toLowerCase())
      return <Package color={color} size={size} weight={weight} />
  }
}
